import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLifeRing } from "@fortawesome/free-solid-svg-icons";
import {
  videoTutorials,
  contactCards,
} from "../../devdata/constants/supportData";
import { ContactCard, VideoTutorial } from "../../components";

export default function HelpSupport() {
  return (
    <div className="flex flex-col bg-darkMode-background min-h-screen p-6">
      <div className="flex flex-wrap gap-6 items-start w-full">
        <div className="flex flex-col pb-10 rounded-xl w-full">
          <div className="flex items-center gap-1 text-2xl font-semibold text-darkMode-text">
            {/* <Link to="/Dashboard"> */}
            {/* <FontAwesomeIcon icon={faArrowLeft} /> */}
            {/* </Link> */}
            <span>Help & Contact Us</span>
          </div>
          <span className="span-sm text-darkMode-subText">
            Find the support you need to manage stocks efficiently.
          </span>
        </div>
      </div>
      {/* Contact Cards Section */}
      <section className="flex md:flex-row lg:flex-row gap-4 px-8 mt-8 w-full flex-wrap">
        {contactCards.map((card, index) => (
          <ContactCard key={index} {...card} />
        ))}
      </section>
    </div>
  );
}
